import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { login } from '../actions/login';
import {
  getIsLoggedIn,
  getLoggedInUser,
  getIsLoginPendingStatus,
} from '../reducers';
import LoginForm from '../components/LoginForm';

const mapStateToProps = (state) => {
  const selector = formValueSelector('login');
  const values = selector(
    state,
    'email',
    'password',
    'verification_code',
    'recaptcha_token',
    'device_uuid',
    'code_sending_mode',
    'target_mdn',
  );

  return {
    formValues: values,
    formRegisteredFields:
      state.form && state.form.login && state.form.login.registeredFields,
    user: getLoggedInUser(state),
    isLoggedIn: getIsLoggedIn(state),
    isPendingStatus: getIsLoginPendingStatus(state),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: ({
    email,
    password,
    recaptcha_token,
    verification_code,
    code_sending_mode,
    target_mdn,
  }) => {
    return new Promise(function (resolve) {
      resolve(
        dispatch(
          login(
            email,
            password,
            recaptcha_token,
            verification_code,
            code_sending_mode,
            target_mdn,
          ),
        ),
      );
    });
  },
});

const Login = connect(mapStateToProps, mapDispatchToProps)(LoginForm);

export default Login;
